import React from "react";
import style from "./TriStateAnswer.module.scss";

export const TriStateAnswer = ({ name, value, onChange, disabled = false }) => {
  const options = [
    { key: "yes", label: "Yes" },
    { key: "no", label: "No" },
    { key: "na", label: "N/A" },
  ];

  return (
    <div className={style.tristate} role="group" aria-label={`${name} answer`}>
      {options.map((o) => (
        <button
          key={o.key}
          type="button"
          data-testid={`${name}-${o.key}`}
          data-answer={o.key}
          className={style.tristate_btn}
          aria-pressed={value === o.key}
          disabled={disabled}
          onClick={() => onChange(o.key)}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
};
